/**
 * @fileoverview Youth Academy API service for ClubOS
 */
import apiClient from "../client";

export const academyService = {
  // ── Dashboard ─────────────────────────────────────────────────────────────
  getDashboard: () => apiClient.get("/academy/dashboard"),

  // ── Age Groups ────────────────────────────────────────────────────────────
  getAgeGroups: () => apiClient.get("/academy/age-groups"),
  saveAgeGroups: (ageGroups) => apiClient.put("/academy/age-groups", { ageGroups }),

  // ── Coach Roles ──────────────────────────────────────────────���─────────────
  getCoachRoles: () => apiClient.get("/academy/coach-roles"),
  saveCoachRoles: (roles) => apiClient.put("/academy/coach-roles", { roles }),

  // ── Training Day Schedules ────────────────────────────────────────────────
  getTrainingDaySchedules: () => apiClient.get("/academy/training-day-schedules"),
  saveTrainingDaySchedules: (trainingDays) => apiClient.put("/academy/training-day-schedules", { trainingDays }),

  // ── Time Slots ────────────────────────────────────────────────────────────
  getTimeSlots: () => apiClient.get("/academy/time-slots"),
  saveTimeSlots: (timeSlots) => apiClient.put("/academy/time-slots", { timeSlots }),

  // ── Coaches ───────────────────────────────────────────────────────────────
  getCoaches: (params) => apiClient.get("/academy/coaches", { params }),
  createCoach: (data) => apiClient.post("/academy/coaches", data),
  updateCoach: (id, data) => apiClient.put(`/academy/coaches/${id}`, data),

  // ── Batches ───────────────────────────────────────────────────────────────
  getBatches: (params) => apiClient.get("/academy/batches", { params }),
  createBatch: (data) => apiClient.post("/academy/batches", data),
  updateBatch: (id, data) => apiClient.put(`/academy/batches/${id}`, data),

  // ── Players ───────────────────────────────────────────────────────────────
  getPlayers: (params) => apiClient.get("/academy/players", { params }),
  createPlayer: (data) => apiClient.post("/academy/players", data),
  updatePlayer: (id, data) => apiClient.put(`/academy/players/${id}`, data),

  // ── Attendance ────────────────────────────────────────────────────────────
  getAttendance: (params) => apiClient.get("/academy/attendance", { params }),
  bulkMarkAttendance: (data) => apiClient.post("/academy/attendance/bulk", data),

  // ── Fees ──────────────────────────────────────────────────────────────────
  getFees: (params) => apiClient.get("/academy/fees", { params }),
  recordFee: (data) => apiClient.post("/academy/fees", data),
  updateFee: (id, data) => apiClient.put(`/academy/fees/${id}`, data),

  // ── Injuries ──────────────────────────────────────────────────────────────
  getInjuries: (params) => apiClient.get("/academy/injuries", { params }),
  createInjury: (data) => apiClient.post("/academy/injuries", data),
  updateInjury: (id, data) => apiClient.put(`/academy/injuries/${id}`, data),

  // ── Training Logs ─────────────────────────────────────────────────────────
  getTrainingLogs: (params) => apiClient.get("/academy/training-logs", { params }),
  createTrainingLog: (data) => apiClient.post("/academy/training-logs", data),
  updateTrainingLog: (id, data) => apiClient.put(`/academy/training-logs/${id}`, data),
};
